export function getTestPasswordEnhacement() {
    return (process.env.TEST_PASSWORD_ENABLED);
}